// 该文件由 OneAPI 自动生成，请勿手动修改！
import { API, API_v2 } from '@/services/config';
import { request } from '@@/exports';
/**
 * 获取系统配置列表( table )
 * @param params
 * @param options
 */
export async function getConfigList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getConfigList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 添加系统配置
 * @param data
 * @param options
 */
export async function addConfig(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addConfig, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改系统配置
 * @param data
 * @param options
 */
export async function editConfig(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editConfig, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除系统配置
 * @param data
 * @param options
 */
export async function delConfig(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delConfig, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取STS
 * @param params
 * @param options
 */
export async function getSts(
  params: {
    company_id: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getSts, {
    method: '' + 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 查询文件详情
 * @param params
 * @param options
 */
export async function getFileLibraryNewDetail(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    file_id: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFileLibraryNewDetail, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 配置oss
 * @param data
 * @param options
 */
export async function addCompanyOss(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    storage_location?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addCompanyOss, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 查询公司是否已配置oss
 * @param params
 * @param options
 */
export async function checkCompanyOssExist(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.checkCompanyOssExist, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/** =============== 文件库相关 ================== **/
/**
 * 获取文件夹列表
 * @param params
 * @param options
 */
export async function getFileDirectoryList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFileDirectoryList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增文件夹
 * @param data
 * @param options
 */
export async function addFileDirectory(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API.addFileDirectory, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改文件夹
 * @param data
 * @param options
 */
export async function editFileDirectory(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API.editFileDirectory, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除文件夹
 * @param data
 * @param options
 */
export async function delFileDirectory(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API.delFileDirectory, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取任务模板列表( table )
 * @param params
 * @param options
 */
export async function task_templates(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_templates, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增任务模板
 * @param data
 * @param options
 */
export async function task_templates_add(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_templates_add, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改任务模板
 * @param data
 * @param options
 */
export async function task_templates_edit(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_templates_edit, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除任务模板
 * @param data
 * @param options
 */
export async function task_templates_del(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_templates_del, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取模板方法列表( table )
 * @param params
 * @param options
 */
export async function task_methods(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string | number;
    template_id?: string | number;
    queer_All?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_methods, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增模板方法
 * @param data
 * @param options
 */
export async function task_methods_add(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_methods_add, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改模板方法
 * @param data
 * @param options
 */
export async function task_methods_edit(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_methods_edit, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除模板方法
 * @param data
 * @param options
 */
export async function task_methods_del(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.task_methods_del, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取限行规则详情
 * @param params
 * @param options
 */
export async function getTrafficRestrictionByDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTrafficRestrictionByDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 查询我发起的列表( table )
 * @param params
 * @param options
 */
export async function getMyInitiatedList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    company_id?: string;
    entity_id?: string;
    workflow_id?: string;
    is_records_query?: string;
    query_all?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMyInitiatedList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 查询我发起的时间轴
 * @param params
 * @param options
 */
export async function getTimeLine(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    instance_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTimeLine, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 我的待办( table )
 * @param params
 * @param options
 */
export async function getMyTodoList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    entity_id?: string;
    query_all?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMyTodoList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 我处理的( table )
 * @param params
 * @param options
 */
export async function getMyHandledList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    entity_id?: string;
    query_all?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMyHandledList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 审批
 * @param data
 * @param options
 */
export async function approveLeaveRequests(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    method_id?: string;
    id?: number;
    approver_result?: string;
    approval_reason?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.approveLeaveRequests, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 取消发起
 * @param data
 * @param options
 */
export async function cancel(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    method_id?: string;
    id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.cancel, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 发起待办统一入口
 * @param data
 * @param options
 */
export async function create(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    method_id?: string;
    platform_id?: string;
    process_id?: number;
    entity_id?: number;
    process_type?: string;
    non_cash_id?: number[] | undefined;
    settlement_method?: string;
    pathlist?: string[];
    remaining_amount?: string[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.create, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 审批统一接口
 * @param data
 * @param options
 */
export async function approve(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    method_id?: string;
    id?: number;
    status?: string;
    reason?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.approve, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 抄送我的( table )
 * @param params
 * @param options
 */
export async function getCopyToMeList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    entity_id?: string;
    query_all?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCopyToMeList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 查询区域信息
 * @param params
 * @param options
 */
export async function getFileAreaList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    entity_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFileAreaList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 查询对应区域的主控
 * @param params
 * @param options
 */
export async function getFileBoardList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    entity_id?: string;
    area_code?: string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFileBoardList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 查询区域对应的柜子
 * @param params
 * @param options
 */
export async function getFileCabinetList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    entity_id?: string;
    board_code?: string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFileCabinetList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 审批统一接口
 * @param data
 * @param options
 */
export async function openCabinet(
  data: {
    locker_code?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.openCabinet, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 读取短信列表
 * @param params
 * @param options
 */
export async function getSmsReceiveRecordList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    company_id?: string;
    board_code?: string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getSmsReceiveRecordList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取短信详情
 * @param params
 * @param options
 */
export async function getSmsReceiveRecordDetail(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: string;
    id?: string;
    board_code?: string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getSmsReceiveRecordDetail, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}